import { LiveSeoRoute } from "~/components/live-seo/LiveSeoRoute";
import {
	getLiveSeoContent,
	type LiveSeoContent,
} from "~/data/liveSeoContent.functions";
import { createFileRoute, notFound } from "@tanstack/react-router";

export const Route = createFileRoute("/$slug")({
	beforeLoad: async ({ params }) => {
		const { isLiveSeoPath, normalizeLiveSeoPath, omittedLivePaths } =
			await import("~/data/liveSeoHeadData");
		const path = normalizeLiveSeoPath(`/${params.slug}`);

		if (
			(omittedLivePaths as readonly string[]).includes(path) ||
			!isLiveSeoPath(path)
		) {
			throw notFound();
		}
	},
	loader: async ({ params }): Promise<LiveSeoContent> => {
		const page = await getLiveSeoContent({ data: `/${params.slug}` });
		if (!page) throw notFound();
		return page;
	},
	head: async ({ params }) =>
		(await import("~/utils/liveSeoHead")).headFromLiveSeo(`/${params.slug}`),
	component: LiveSeoRoute,
});
